import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";
import { motion } from "framer-motion"; // Import framer-motion

function AboutCard() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }} // Animation on mount
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <Card className="quote-card-view">
        <Card.Body>
          <blockquote className="blockquote mb-0">
            <motion.p
              style={{ textAlign: "justify" }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.2 }}
            >
              Hello! I am <span className="purple">Rahul Kumar Yadav</span>, a passionate software developer from 
              <span className="purple"> Pune, India.</span>
              <br /> I hold a Bachelor of Engineering in Information Technology from the prestigious Army Institute of Technology.
              <br />
              With <span className="purple">2 years of professional experience</span>, I have honed my skills in building scalable and efficient software solutions. <br />
              I had the privilege of working at Oriserve as an Associate Software Development Engineer, where I contributed to impactful projects and collaborated with talented teams.
              <br />
              <br />
              Beyond coding, I am driven by a curiosity to explore and learn. Here are a few activities I enjoy in my free time:
            </motion.p>
            <ul>
              <motion.li
                className="about-activity"
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.4 }}
              >
                <ImPointRight /> Immersing myself in gaming adventures
              </motion.li>
              <motion.li
                className="about-activity"
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.6 }}
              >
                <ImPointRight /> Sharing knowledge through tech blogs
              </motion.li>
              <motion.li
                className="about-activity"
                initial={{ x: -50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{ duration: 0.5, delay: 0.8 }}
              >
                <ImPointRight /> Traveling to discover new cultures and experiences
              </motion.li>
            </ul>

            <motion.p
              style={{ color: "rgb(155 126 172)" }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 1 }}
            >
              "Strive not just to build software, but to create solutions that inspire and make a difference!"{" "}
            </motion.p>
            <footer className="blockquote-footer">Rahul</footer>
          </blockquote>
        </Card.Body>
      </Card>
    </motion.div>
  );
}

export default AboutCard;
